import { useTenantNavigate } from '@app-store'
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import {
  DropDownList,
  SvgAvailabelAgentsListing,
  DropdownType,
  NAMESPACE,
  CustomButton,
  ConfirmationModal,
  Modal,
  SORT_KEYS,
  ConfirmDialogWithReason,
  SvgVerticalSplitter,
  filterOperatorValues,
  ExportButtonDropdown,
} from '@ui-kit'
import {
  addToaster,
  DataTypeStore,
  getLayoutByIdApi,
  getQueueByIdApi,
  getQueueLayoutData,
  hideLoader,
  setSelectedQueueReducer,
  showLoader,
  TableFilterObjectBody,
  getOldestWorkForAgentAPI,
  ErrorResponseData,
  bulkAssignToAgent,
  TableFilterLookupObjectBody,
  LookupSearchCriteria,
  getProgramWiseAgentsAPI,
  fetchPrintDocument,
  getCaseStatuses,
  updateStatusPrintMailAPI,
  generateCommuncationStatusesAPI,
  bulkDiscardVoidPrintLetter,
  ErrorResponse,
  setClientDropdown,
  updateAuthUserSelectedTenant,
  DropDownOptionType,
  DataType,
  AgentType,
  getAllUsers,
  exportEntityDataByEntityIdLayoutIdApiForFilter,
  ToasterTypeValues,
  ToasterType,
  navigateWithTenant,
  setSessionLastTenantId,
} from '@app-store'
import {
  COMMUNICATION_STATUSES,
  COMM_TEMPLATE,
  CONTEXT_TYPE,
  DASHBOARD,
  ENTITY_NAME,
  FIELD_VALUE_CONSTANTS,
  NAMESPACES,
  PAGINATION,
  PERMISSION_ACCESSIBILITY,
  PERMISSION_MODULES,
  USER_PROFILES,
  ENTITY_TABLE_EXPORT_EVENT,
  componentNames,
  EXPORT_FIELD_ALIASES,
  FIELD_NAMES,
  FILTER_OPERATIONS,
  HTTP_STATUS_CONSTANTS,
} from '../../utils/constants'
import { isEmpty, noop, startCase, uniqueId } from 'lodash'
import { useEffect, useRef, useState, useMemo, useCallback } from 'react'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import {
  formatDataForListView,
  formatFilterConfig,
  getTableHeadersFromLayout,
  // isWithinLast24Hours,
} from '../../utils/listing.utils'
import { EntityLayout } from '../../types/layout.types'
import {
  AgentsData,
  DynamicQueuesProps,
  DynamicQueuesType,
  PrintMailConfig,
  QueueCriterum,
  QueUeDataFilter,
} from '../../types/queueConfig.types'
import { QueueTable } from './QueueTable'
import {
  assignCasesWithAgent,
  assignUnassignTasksWithCases,
  postValidateCasesWithAgent,
  unassignCasesWithAgent,
  assignWebCasesQueueToAgent,
} from '../../apis/entityData.api'
import {
  DYNAMIC_QUEUE_CONSTANTS,
  DYNAMIC_QUEUE_MESSAGES,
  PRINT_MAIL_ACTIONS,
  PRINT_MAIL_ACTIONS_ENUM,
} from '../../constants/dynamicQueue'
import { v4 as uuid } from 'uuid'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import { AxiosError, isAxiosError } from 'axios'
import {
  buildAgentLabel,
  fetchEntityIdByName,
  formatFaxNumber,
  getTomorrowDate,
  openNewWindow,
  permissionObject,
  programPermissionsObject,
  downloadCSV,
  buildUiDataMappings,
  parseErrorMessage,
} from '../../utils/helperFunctions'
import {
  ExportPayloadType,
  RelatedEntityType,
} from '../../types/correspondenceLogs.types'
import { isSuperAdmin, isReadOnlyUser } from '../../utils/permission'
import { useFocusFirstElement } from '../../hooks/useFocusFirstFocusableElement'
import { PRINT_MAIL_STRING, STRINGS } from '../../utils/strings'
import {
  FilterCriteriaForQueue,
  QueueFilterType,
  RelatedEntitiesForQueue,
  ResolveType,
  TableColumn,
} from '../../types/types'
import printJS from 'print-js'
import { ActionsDropDown } from '../../components/queue-config/ActionsPopUp'
import TableViewsDropdown from '../../components/user-preferences/TableViewsDropdown'

const DynamicQueues: React.FC<DynamicQueuesProps> = ({ ...props }) => {
  const initialState: {
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  } = {
    key: '',
    isAsc: SORT_KEYS.Disabled,
    keyName: '',
    direction: SORT_KEYS.Disabled,
  }

  const printMailInitialState: PrintMailConfig = {
    unassignedLetters: false,
    isAssignedToOthers: false,
    letterStatus: {
      isPending: false,
      isProcessing: false,
      isDiscard: false,
      isInvalid: false,
    },
  }

  const userProfile = useAppSelector(
    (state: RootState) => state?.authUser.user?.profile
  )
  const authUser = useAppSelector((state: RootState) => state?.authUser)
  const siteSettings = useAppSelector((state) => state?.authUser?.site_settings)
  const {
    entityid: paramEntityId,
    layoutid: paramLayoutId,
    id: paramId,
  } = useParams()

  const entityid = paramEntityId ?? props.entityid
  const layoutid = paramLayoutId ?? props.layoutid
  const id = paramId ?? props.id
  const location = useLocation()
  const navigateBase = useNavigate()
  const dispatch = useAppDispatch()
  const navigate = useTenantNavigate()
  const selectedTenant = useAppSelector(
    (state: RootState) => state?.authUser?.selectedClientTenant
  )

  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const programs = useAppSelector(
    (state: RootState) => state.clientPermissions.programs
  )
  const programServices = useAppSelector(
    (state: RootState) => state.clientPermissions.programServices
  )
  const user = useAppSelector((state: RootState) => state?.authUser?.user)
  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)
  const selectedClientName = useAppSelector(
    (state: RootState) =>
      state?.authUser?.selectedClientTenant?.name_of_organization
  )
  const allPermissions = useAppSelector(
    (state) => state?.allPermissions?.permissions
  )

  const [modal, setModal] = useState<{
    type: string
    state: boolean
    resolve?: ResolveType
  }>({
    type: '',
    state: false,
    resolve: undefined,
  })

  const [voidDiscradModalState, setvoidDiscradModalState] = useState({
    isOpen: false,
    message: '',
    validationMessage: '',
    actionSelected: '',
  })
  const [rowPerPage, setRowPerPage] = useState<number>(PAGINATION.ROWS_PER_PAGE)
  const [listingLayout, setListingLayout] = useState<EntityLayout>()
  const [totalPages, setTotalPages] = useState<number>(
    FIELD_VALUE_CONSTANTS.ONE
  )
  const [entityData, setEntityData] = useState<DataTypeStore[]>([])
  const [queueData, setQueueData] = useState<DynamicQueuesType>()
  const [queueType, setQueueType] = useState<string>('')
  const [programServiceIds, setProgramServiceIds] = useState<{
    [key: string]: string[]
  }>({})
  const queueColumnsStr = useAppSelector(
    (state: RootState) =>
      queueData?.id &&
      selectedTenant?.id &&
      state.tableColumn.tableColumn[
        `queue-${queueData.id}-${selectedTenant?.id}`
      ]
  )
  const queueColumns = queueColumnsStr && JSON.parse(queueColumnsStr)
  const [sortDirection, setSortDirection] = useState<{
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  }>(initialState)
  const [allAgents, setAllAgents] = useState<DropdownType<string>[]>([])
  const [allAvailableAgents, setAllAvailableAgents] = useState<
    DropdownType<string>[]
  >([])
  const allAvailableAgentsBeforeSearch = useRef<DropdownType<string>[]>([])
  const allAgentsBeforeSearch = useRef<DropdownType<string>[]>([])
  const [selectedRows, setSelectedRows] = useState<string[]>([])
  const [completeSelectedRows, setCompleteSelectedRows] = useState<DataType[]>(
    []
  )
  const [currentPage, setCurrentPage] = useState<number>(
    FIELD_VALUE_CONSTANTS.ONE
  )
  const [totalElements, setTotalElements] = useState<number>(
    FIELD_VALUE_CONSTANTS.ONE
  )
  const [numberOfElements, setNumberOfElements] = useState<number>(
    FIELD_VALUE_CONSTANTS.ONE
  )
  // const [apiFilter, setApiFilter] = useState<
  //   TableFilterObjectBody | undefined
  // >()
  // const [showTableType, setShowTableType] = useState<string>(uniqueKey)
  const [caseEntityId, setCaseEntityId] = useState<number>()
  const [headerValues, setHeaderValues] = useState<DataTypeStore>({
    selected: false,
  })
  const [entityName, setEntityName] = useState<string>('')
  const configColumns = getTableHeadersFromLayout(listingLayout)
  const [completedStatus, setCompletedStatus] = useState<string[]>([])
  const [communicationStatuses, setCommunicationStatuses] = useState<
    {
      label: string
      id: string
    }[]
  >([])
  const [queueFilterCriteria, setQueueFilerCriteria] =
    useState<FilterCriteriaForQueue[]>()
  const [queueFilterRealtedEntities, setQueueFilerRelatedEntities] =
    useState<RelatedEntitiesForQueue>()

  const [printMailUserConfig, setPrintMailUserConfig] =
    useState<PrintMailConfig>(printMailInitialState)
  const [apiFilter, setApiFilter] = useState<TableFilterObjectBody | undefined>(
    props?.isTaskWorkBasket
      ? {
          fields: null,
          search_criteria: {
            due_date: {
              operator: filterOperatorValues?.IS_BEFORE,
              search_key: 'due_date',
              search_value: [getTomorrowDate()],
            },
          },
        }
      : undefined
  )

  const isMounted = useRef<boolean>(false)
  const hasFetchedCaseStatusesRef = useRef<boolean>(false)
  const getWorkInFlightRef = useRef(false)
  const [isGetWorkLoading, setIsGetWorkLoading] = useState(false)
  const getWorkButtonRef = useRef<HTMLButtonElement>(null)
  const isValidEntity =
    entityName === ENTITY_NAME.CASE_LOWER ||
    entityName === ENTITY_NAME.COMMUNICATION ||
    entityName === QUEUE_STRINGS?.HCP_PORTAL_ENTITY_LOWERCASE ||
    entityName === ENTITY_NAME?.AE_PC_DOCUMENT ||
    props.isDashboard

  const shouldShowBulkUnassign = () =>
    selectedRows.every((id) => {
      const record = entityData.find((item) => String(item.id) === id)
      return (record && record.users) ?? record?.['assignee.id']
    })
  const shouldShowAgentDropdown = isValidEntity && selectedRows.length > 0
  const shouldShowActionDropdown = useMemo(() => {
    if (!isValidEntity || selectedRows.length === 0) {
      return false
    }
    const rowsAssignedToCurrentUser = selectedRows.every((selectedRowId) => {
      const row = entityData.find(
        (item) => item?.id?.toString() === selectedRowId?.toString()
      )
      if (!row) return false
      const assigneeId = row['users.id']
      return assigneeId && assigneeId.toString() === userId?.toString()
    })
    return rowsAssignedToCurrentUser
  }, [selectedRows, entityData, userId, isValidEntity])

  const ref = useRef<HTMLDivElement | null>(null)
  useFocusFirstElement(ref)
  const handlePageDataFromChild = (data: number) => {
    setCurrentPage(data)
  }

  const handleFilterDataFromChild = (data: TableFilterObjectBody) => {
    setApiFilter(data)
  }

  const fetchLayoutById = async (entity_id: string, layout_id: string) => {
    try {
      dispatch(showLoader())
      if (props.isDashboard) {
        const layout = await props.fetchDashboardLayout?.()
        if (layout) {
          setListingLayout(layout)
        }
      } else {
        const response = await getLayoutByIdApi({
          entityId: entity_id,
          layoutId: layout_id,
        })
        if (response) {
          setListingLayout(response?.data)
        }
      }
    } catch (err) {
      console.error('Error', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getProgramIds = () => {
    const programIdsWithPermission =
      programPermissionsObject.Queues_And_Cases_View(
        programPermissions,
        PERMISSION_MODULES.QUEUE_AND_CASE_VISIBILITY,
        'View Only'
      )
    return programIdsWithPermission
  }

  const getNameForDashboradData = () => {
    if (props.dashboardListName === DASHBOARD.DOCUMENT) {
      return DASHBOARD.DOCUMENTS_DATA
    } else if (props.dashboardListName === ENTITY_NAME.CASE) {
      return DASHBOARD.CASES
    } else {
      return ''
    }
  }

  const getName = (): string => {
    if (props.isCaseWorkBasket) return DASHBOARD.MY_CASES
    else if (props.isTaskWorkBasket) return DASHBOARD.MY_TASKS
    else if (props.isDashboard) return getNameForDashboradData()
    else return queueData?.name ?? ''
  }

  const getProgramNamesForCriteria = (names?: string[]): string[] => {
    return names?.length ? names : ['']
  }

  const getKeyName = (entityName: string) => {
    return entityName === 'hcp_portal_entity' ? 'hcp_program' : 'programs'
  }
  const buildProgramViewPermission = (programNames: string[]) => {
    return {
      criteria: [
        {
          field_name: 'operational_program_name',
          values: getProgramNamesForCriteria(programNames),
          operation: 'IN',
        },
      ],
    }
  }

  const initializeRelatedEntityFilter = (
    formatFilter: {
      filter_criteria: LookupSearchCriteria[]
      related_entities: TableFilterLookupObjectBody
    },
    key: string
  ) => {
    if (!formatFilter.related_entities) {
      formatFilter.related_entities = {}
    }

    if (!formatFilter.related_entities[key]) {
      formatFilter.related_entities[key] = { filters: [] }
    }
  }

  const fetchEntityData = async (
    apiFilter?: TableFilterObjectBody,
    rowsPerPage = 25,
    currentPage = 0,
    resetPage = false
  ) => {
    try {
      if (!isSuperAdmin() && Object.keys(programPermissions).length === 0)
        return
      if (resetPage) setCurrentPage(0)
      const programNames = getProgramIds()?.map((id) => programs[id])
      dispatch(showLoader())
      const keys = Object.keys(listingLayout?.layout_data?.added_fields ?? {})

      if (!keys?.includes('id')) {
        keys.unshift('id')
      }
      const formatFilter: {
        filter_criteria: LookupSearchCriteria[]
        related_entities: TableFilterLookupObjectBody
      } =
        apiFilter ?? sortDirection
          ? (formatFilterConfig(apiFilter ?? {}, configColumns, 'Queue', {
              key: sortDirection?.key,
              direction: sortDirection?.direction?.toUpperCase(),
            }) as {
              filter_criteria: LookupSearchCriteria[]
              related_entities: TableFilterLookupObjectBody
            })
          : { filter_criteria: [], related_entities: {} }

      if (!isSuperAdmin()) {
        const key = getKeyName(entityName)
        const permission = buildProgramViewPermission(programNames)

        initializeRelatedEntityFilter(formatFilter, key)
        formatFilter.related_entities[key].filters.push(permission)
      }

      if (formatFilter.filter_criteria?.length) {
        formatFilter.filter_criteria.forEach((criteria) => {
          if (criteria.field_name === 'urgency_index_status.overdue_time') {
            formatFilter.related_entities.urgency_index_status.filters.push({
              logical_operator: 'OR',
              criteria: [
                {
                  field_name: 'overdue_time',
                  values: criteria.values || [],
                  operation: criteria.operation || '',
                  direction: criteria.sort_direction?.toUpperCase(),
                },
              ],
            })
            if (
              !formatFilter.related_entities.urgency_index_status.select?.includes(
                'overdue_time'
              )
            ) {
              formatFilter.related_entities.urgency_index_status.select?.push(
                'overdue_time'
              )
            }
          }
        })
        formatFilter.filter_criteria = formatFilter.filter_criteria.filter(
          (item) => item.field_name !== 'urgency_index_status.overdue_time'
        )
      }

      if (props?.isTaskWorkBasket) {
        formatFilter.filter_criteria.push(
          ...[
            {
              field_name: 'user_id',
              values: [`${userId}`],
              operation: 'EQUALS',
            },
            {
              field_name: 'task_status',
              values: ['COMPLETED', 'CANCELLED'],
              operation: 'NOT_EQUALS',
            },
          ]
        )
      }
      if (props?.isCaseWorkBasket) {
        let filterOrder = 4
        const casesFilters =
          formatFilter?.related_entities?.['c_case_statuses']?.filters?.[0]
            .criteria ?? []
        const userFilters =
          formatFilter?.related_entities?.['users']?.filters?.[0].criteria ?? []
        formatFilter.filter_criteria = formatFilter.filter_criteria
          .filter(
            (filter) =>
              filter.field_name !== 'case_status_id' &&
              filter.field_name !== 'modified_at'
          )
          ?.map((filter) => ({
            ...filter,
            preceding_condition: 'AND',
            order: filterOrder++,
          }))

        formatFilter?.filter_criteria.push(
          {
            field_name: 'case_status_id',
            order: 3,
            preceding_condition: 'OR',
            values: [...completedStatus],
            operation: 'NOT_EQUALS',
          },
          {
            field_name: 'case_status_id',
            order: 1,
            preceding_condition: 'OR',
            values: [...completedStatus],
            operation: 'EQUALS',
          }
        )

        const currentDate = new Date()
        const oneDayBefore = new Date(currentDate)
        oneDayBefore.setHours(currentDate.getHours() - 24)

        formatFilter?.filter_criteria.push({
          field_name: 'modified_at',
          order: 2,
          preceding_condition: 'AND',
          values: [oneDayBefore.toISOString(), currentDate.toISOString()],
          operation: 'BETWEEN',
        })

        formatFilter.related_entities = {
          ...formatFilter.related_entities,
          c_case_statuses: {
            filters: [
              {
                criteria: [...casesFilters],
              },
            ],
          },
          users: {
            filters: [
              {
                criteria: [
                  ...userFilters,
                  {
                    field_name: 'id',
                    values: [`${userId}`],
                    operation: 'EQUALS',
                  },
                ],
              },
            ],
          },
        }
      }
      let entity
      if (props.isDashboard) {
        entity = await props?.embeddedDashboardData?.(
          apiFilter,
          resetPage ? 0 : currentPage,
          rowsPerPage,
          sortDirection
        )
      } else {
        entity = await getQueueLayoutData(Number(id), {
          filterCriteria: formatFilter,
          size: rowsPerPage,
          page: resetPage ? 0 : currentPage,
        })
      }
      if (entity) {
        let formattedTempData: DataTypeStore[] = []
        const tempData = formatDataForListView(
          entity?.data?.content,
          listingLayout?.layout_data,
          true
        )
        formattedTempData = tempData?.map((entry) => ({
          ...entry,
          sender_name: entry?.communication_id?.toString()?.startsWith('M-')
            ? entry?.sender_name
            : formatFaxNumber(String(entry?.sender_name)),
          created_at: entry?.created_at,
        }))
        const updatedTempData = formattedTempData.map((item) => ({
          ...item,
          task_id: `T - ${item?.task_id}`,
        }))

        props.isTaskWorkBasket
          ? setEntityData(updatedTempData)
          : setEntityData(formattedTempData)

        setTotalPages(entity?.data?.totalPages ?? 1)
        setTotalElements(entity?.data?.totalElements ?? 1)
        setNumberOfElements(entity?.data?.numberOfElements ?? 1)
        if (rowsPerPage) {
          setRowPerPage(rowsPerPage)
        }
      }
    } catch (err) {
      setEntityData([])
      console.error(err)
    } finally {
      dispatch(hideLoader())
      if (!props?.isCaseWorkBasket && !props?.isTaskWorkBasket)
        isMounted.current = true
    }
  }

  const fetchAgentsData = async () => {
    try {
      dispatch(showLoader())
      let response
      if (props.isDashboard) {
        response = await getAllUsers()
      } else {
        response = await getProgramWiseAgentsAPI(
          programServiceIds,
          entityName !== ENTITY_NAME.CASE_LOWER
        )
      }
      if (response) {
        const convertedArray = response?.data?.map((item: AgentsData) => ({
          label: `${item?.first_name ?? ''} ${item?.last_name ?? ''} | ${
            item.user_id ?? ''
          }`,
          value: item?.id?.toString(),
          id: item.id,
          name: `${item.first_name ?? ''} ${item.last_name ?? ''}`,
        }))
        setAllAgents(convertedArray)
        allAgentsBeforeSearch.current = convertedArray
      }
      dispatch(hideLoader())
    } catch (err) {
      console.error('Error', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchQueueById = async (id: number) => {
    try {
      dispatch(showLoader())
      const response = await getQueueByIdApi(id)
      if (response) {
        setQueueFilerCriteria(response?.data?.filter_criteria)
        setQueueFilerRelatedEntities(response?.data?.related_entities)
        setEntityName(response?.data?.entity_name)
        setQueueData(response?.data)
        const criteriaList =
          response?.data?.related_entities?.category_communication_type?.filters?.flatMap(
            (filter: QueUeDataFilter) => filter.criteria
          )

        const firstValidValue = criteriaList?.find(
          (criterion: QueueCriterum) =>
            Array.isArray(criterion.values) && criterion.values[0]
        )?.values[0]

        if (firstValidValue) {
          setQueueType(firstValidValue.toLowerCase())
        }

        dispatch(setSelectedQueueReducer(response?.data?.name))
      }
    } catch (err) {
      console.error('Error', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const onClientOptionChange = (value: DropdownType<DropDownOptionType>) => {
    if (value?.label === selectedTenant?.name_of_organization) {
      return
    }
    const tid = parseInt(String(value.value), 10)
    if (!Number.isFinite(tid)) return
    navigateWithTenant(
      navigateBase,
      { pathname: '/', search: '' },
      { replace: true },
      tid
    )
    setSessionLastTenantId(tid)
    dispatch(updateAuthUserSelectedTenant(tid))
  }

  const onClientModalConfirm = () => {
    if (modal.type === 'redirect') {
      setModal({
        type: '',
        state: false,
        resolve: undefined,
      })
      modal.resolve?.(true)
    } else if (
      modal.type === DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_BULK_UNASSIGN_MESSAGE
    ) {
      handleBulkUnassign()
      setModal({
        type: '',
        state: false,
      })
    }
  }

  const onClientModalCancel = () => {
    if (modal.type === 'redirect') {
      setModal({
        type: '',
        state: false,
        resolve: undefined,
      })
      modal.resolve?.(false)
    } else if (
      modal.type === DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_BULK_UNASSIGN_MESSAGE
    ) {
      setModal({
        type: '',
        state: false,
      })
    }
  }

  const handlePrint = async () => {
    try {
      dispatch(showLoader())
      const docIds = selectedRows.join(',')
      const bulkDoc = await fetchPrintDocument(docIds)
      const statusResponse = await updateStatusPrintMailAPI(
        selectedRows.join(','),
        {
          meta_data: {
            entity_id: entityid ?? '-1',
            layout_id: layoutid ?? '-1',
          },
          data: {
            category_status_id:
              communicationStatuses?.find(
                (res) =>
                  res.label === COMMUNICATION_STATUSES?.PROCESSING_PRINTING
              )?.id ?? '-1',
          },
        },
        entityName
      )

      if (statusResponse) {
        dispatch(
          addToaster({
            id: uuid(),
            message: PRINT_MAIL_STRING.PROCESSING_PRINTING,
            type: 'success',
          })
        )
      }
      const res = await fetch(bulkDoc.data)
      if (res.url) {
        dispatch(hideLoader())
        printJS({
          printable: res.url.replace(/\s+/g, ''),
          type: 'pdf',
          onPrintDialogClose: () => {
            afterPrintCallback()
          },
        })
      }
    } catch (error) {
      dispatch(hideLoader())
      console.error(error)
    }
  }

  const handleMarkAsCompleted = async () => {
    try {
      dispatch(showLoader())
      const statusResponse = await updateStatusPrintMailAPI(
        selectedRows.join(','),
        {
          meta_data: {
            entity_id: entityid ?? '-1',
            layout_id: layoutid ?? '-1',
          },
          data: {
            category_status_id:
              communicationStatuses?.find(
                (res) => res.label === COMMUNICATION_STATUSES?.COMPLETED
              )?.id ?? '-1',
          },
        },
        entityName
      )

      if (statusResponse) {
        dispatch(
          addToaster({
            id: uuid(),
            message: PRINT_MAIL_STRING.COMPLETED,
            type: 'success',
          })
        )
      }
      dispatch(hideLoader())
      afterPrintCallback()
    } catch (error) {
      dispatch(hideLoader())
      console.error(error)
    }
  }

  const handleMarkAsVoidedDiscarded = async (
    reason: string,
    actionSelected:
      | PRINT_MAIL_ACTIONS_ENUM.DISCARDED
      | PRINT_MAIL_ACTIONS_ENUM.VOIDED
  ) => {
    try {
      dispatch(showLoader())
      const statusResponse = await bulkDiscardVoidPrintLetter({
        communication_ids: selectedRows,
        reason: reason,
        reviewer: userId ?? -1,
        status: actionSelected,
      })
      setvoidDiscradModalState({
        isOpen: false,
        actionSelected: '',
        message: '',
        validationMessage: '',
      })
      if (statusResponse) {
        dispatch(
          addToaster({
            id: uuid(),
            message:
              actionSelected === PRINT_MAIL_ACTIONS_ENUM.DISCARDED
                ? PRINT_MAIL_STRING.DISCARDED
                : PRINT_MAIL_STRING.VOIDED,
            type: 'success',
          })
        )
      }
      dispatch(hideLoader())
      afterPrintCallback()
    } catch (error) {
      dispatch(hideLoader())
      setvoidDiscradModalState({
        isOpen: false,
        actionSelected: '',
        message: '',
        validationMessage: '',
      })
      const errorMessage = (error as AxiosError)?.response
        ?.data as ErrorResponse
      if (errorMessage?.message) {
        dispatch(
          addToaster({
            message: errorMessage?.message,
            type: 'error',
            id: uuid(),
          })
        )
      }
      console.error(error)
    }
  }

  const afterPrintCallback = () => {
    setSelectedRows([])
    setCompleteSelectedRows([])
    setHeaderValues({ selected: false })
    setPrintMailUserConfig(printMailInitialState)
    setHeaderValues({ selected: false })
    fetchLayoutById(entityid ?? '-1', layoutid ?? '-1')
    fetchQueueById(Number(id))
  }

  const HCPAssign = async (agentId: DropdownType<string> | null) => {
    const idsToAssign = completeSelectedRows.map(
      (row) => row?.enrollment_id?.toString() ?? row.id?.toString() ?? ''
    )
    const success = await assignCasesWithAgent(
      idsToAssign,
      agentId,
      layoutid,
      entityid,
      entityName
    )
    if (success) {
      setSelectedRows([])
      setCompleteSelectedRows([])
      setHeaderValues({ selected: false })
      dispatch(
        addToaster({
          id: uuid(),
          message: `${DYNAMIC_QUEUE_MESSAGES.ASSIGN_INTAKE_TO_AGENT} ${agentId?.name}.`,
          type: 'success',
        })
      )
    }
  }

  const AssignCaseToAgent = async (agentId: DropdownType<string> | null) => {
    let success
    if (props.isDashboard) {
      success = await props?.handleAssignUnassignForDashboard?.(
        {
          label: agentId?.label ?? '',
          value: agentId?.value ?? '',
          id: Number(agentId?.id) ?? '',
          status: agentId?.status?.toString() ?? '',
        },
        completeSelectedRows
      )
    } else {
      success = await assignCasesWithAgent(
        selectedRows,
        agentId,
        layoutid,
        entityid,
        entityName
      )
    }
    if (success) {
      setSelectedRows([])
      setHeaderValues({ selected: false })
      setCompleteSelectedRows([])
      dispatch(
        addToaster({
          id: uuid(),
          message: `${DYNAMIC_QUEUE_MESSAGES.ASSIGN_CASE_TO_AGENT} ${agentId?.name}.`,
          type: 'success',
        })
      )
    }
  }

  const handleAssign = async (agentId: DropdownType<string> | null) => {
    try {
      if (selectedRows.length === 0) {
        dispatch(
          addToaster({
            id: uuid(),
            message: DYNAMIC_QUEUE_MESSAGES.ASSIGN_ATLEAST_ONE_CASE,
            type: 'error',
          })
        )
      } else if (!agentId && selectedRows.length > 0) {
        dispatch(
          addToaster({
            id: uuid(),
            message: DYNAMIC_QUEUE_MESSAGES.ASSIGN_ATLEAST_ONE_AGENT,
            type: 'error',
          })
        )
      } else if (agentId && selectedRows.length > 0) {
        dispatch(showLoader())
        if (
          props?.isDashboard &&
          props?.dashboardListName === 'Intake' &&
          props?.handleAssignUnassignForDashboard
        ) {
          await props?.handleAssignUnassignForDashboard(
            {
              label: agentId?.label ?? '',
              value: agentId?.value ?? '',
              id: Number(agentId?.id) ?? '',
              status: agentId?.status?.toString() ?? '',
            },
            completeSelectedRows
          )
          setSelectedRows([])
          setCompleteSelectedRows([])
          setHeaderValues({ selected: false })
          dispatch(
            addToaster({
              id: uuid(),
              message: `${DYNAMIC_QUEUE_MESSAGES.ASSIGN_INTAKE_TO_AGENT} ${agentId?.name}.`,
              type: 'success',
            })
          )
        } else if (
          queueData?.entity_name?.toLowerCase() === ENTITY_NAME.COMMUNICATION ||
          queueData?.entity_name?.toLowerCase() === ENTITY_NAME?.AE_PC_DOCUMENT
        ) {
          await bulkAssignToAgentFunction(agentId)
          if (
            props?.isDashboard &&
            props?.dashboardListName === DASHBOARD.DOCUMENT &&
            props?.handleAssignUnassignForDashboard
          ) {
            await props?.handleAssignUnassignForDashboard(null, [])
          }
        } else if (
          queueData?.entity_name?.toLowerCase() ===
          ENTITY_NAME.HCP_PORTAL_ENTITY
        ) {
          await HCPAssign(agentId)
        } else {
          const response = await postValidateCasesWithAgent(
            agentId?.id as string,
            selectedRows
          )
          if (response) {
            await AssignCaseToAgent(agentId)
          }
        }
        fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
      }
    } catch (error) {
      const errorMessage =
        (error as AxiosError<ErrorResponseData>).response?.data?.message ?? ''
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }

  const handleBulkUnassign = async () => {
    try {
      const agentId = authUser?.user
      const agent = {
        label: buildAgentLabel(agentId),
        value: agentId?.user_id ?? '',
        id: agentId?.id ?? 0,
        status: DYNAMIC_QUEUE_CONSTANTS.UNAVAILABLE,
      }
      setModal({ type: '', state: false })
      dispatch(showLoader())
      let response
      if (
        props.isDashboard &&
        (props.dashboardListName === ENTITY_NAME.CASE ||
          props.dashboardListName === 'Intake')
      ) {
        response = await props?.handleAssignUnassignForDashboard?.(
          null,
          completeSelectedRows
        )
      } else {
        response = await unassignCasesWithAgent(
          selectedRows,
          agent,
          layoutid,
          entityid,
          entityName
        )
      }
      if (response) {
        dispatch(
          addToaster({
            id: uuid(),
            message:
              entityName === ENTITY_NAME.CASE_LOWER
                ? DYNAMIC_QUEUE_MESSAGES.BULK_UNASSIGNED_SUCCESS_CASE
                : DYNAMIC_QUEUE_MESSAGES.BULK_UNASSIGNED_SUCCESS_INTAKE,
            type: 'success',
          })
        )
        setSelectedRows([])
        setCompleteSelectedRows([])
        setHeaderValues({ selected: false })
      }
      fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
      if (
        props.isDashboard &&
        props.dashboardListName === DASHBOARD.DOCUMENT &&
        props.handleAssignUnassignForDashboard
      ) {
        await props.handleAssignUnassignForDashboard(null, [])
      }
    } catch (error) {
      dispatch(
        addToaster({
          id: uuid(),
          message:
            entityName === ENTITY_NAME.CASE_LOWER
              ? DYNAMIC_QUEUE_MESSAGES.BULK_UNASSIGNED_ERROR_CASE
              : DYNAMIC_QUEUE_MESSAGES.BULK_UNASSIGNED_ERROR_INTAKE,
          type: 'error',
        })
      )
      console.error(error)
    } finally {
      dispatch(hideLoader())
    }
  }

  const bulkAssignToAgentFunction = async (
    agentId: DropdownType<string> | null
  ) => {
    try {
      let response
      if (entityName === QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE) {
        const idsToAssign = completeSelectedRows.map(
          (row) => row?.enrollment_id?.toString() ?? row.id?.toString() ?? ''
        )
        response = await assignWebCasesQueueToAgent(
          idsToAssign,
          agentId?.id?.toString() ?? ''
        )
      } else {
        response = await bulkAssignToAgent({
          queueId: parseInt(id ?? ''),
          userId: parseInt(agentId?.id?.toString() ?? ''),
          recordsIds: selectedRows,
        })
      }
      if (response) {
        setSelectedRows([])
        setCompleteSelectedRows([])
        setHeaderValues({ selected: false })
        dispatch(
          addToaster({
            id: uuid(),
            message: `${
              queueType === COMM_TEMPLATE.LETTER_EN.toLowerCase()
                ? DYNAMIC_QUEUE_MESSAGES.ASSIGN_LETTER_TO_AGENT
                : DYNAMIC_QUEUE_MESSAGES.ASSIGN_INTAKE_TO_AGENT
            } ${agentId?.name}.`,
            type: 'success',
          })
        )
      }
    } catch (error) {
      console.error(error)
      setSelectedRows([])
      setCompleteSelectedRows([])
      setHeaderValues({ selected: false })
      dispatch(
        addToaster({
          id: uuid(),
          message: DYNAMIC_QUEUE_MESSAGES.ERROR_VALIDATE_CASE_WITH_AGENT,
          type: 'error',
        })
      )
    }
  }

  const handleSearch = (e: string, key: string) => {
    if (e === '') {
      setAllAgents(allAgentsBeforeSearch.current)
      return
    }
    const searchValue = e.toLowerCase()
    switch (key) {
      case DYNAMIC_QUEUE_CONSTANTS.AVAILABLE_AGENTS:
        setAllAvailableAgents(
          allAvailableAgentsBeforeSearch.current.filter((option) =>
            option.label.toLowerCase().includes(searchValue)
          )
        )
        break
      case DYNAMIC_QUEUE_CONSTANTS.ASSIGN_TO_AGENTS:
        setAllAgents(
          allAgentsBeforeSearch.current.filter((option) =>
            option.label.toLowerCase().includes(searchValue)
          )
        )
        break
      default:
        break
    }
  }

  const handleGetWorkAssignment = async () => {
    const shouldBlockAccess =
      entityName !== ENTITY_NAME.CASE_LOWER &&
      userProfile === NAMESPACES.STANDARD_USER &&
      !permissionObject.Permission_Set_Assignment_View(
        programPermissions,
        entityName === ENTITY_NAME?.AE_PC_DOCUMENT
          ? PERMISSION_MODULES.MANAGE_ATTACHMENTS
          : PERMISSION_MODULES.INTAKE_TRIAGE,
        PERMISSION_ACCESSIBILITY.MANAGE
      )

    if (shouldBlockAccess) {
      dispatch(
        addToaster({
          id: uuid(),
          message: STRINGS.UNABLE_GET_WORK,
          type: 'error',
        })
      )
      return
    }

    getWorkButtonRef.current?.blur()
    void getWorkAgents()
  }

  const getAssignedQueueConfig = (idType: string) => {
    switch (idType) {
      case DYNAMIC_QUEUE_CONSTANTS.INTAKE_ID:
        return DYNAMIC_QUEUE_CONSTANTS.INTAKE_LOWERCASE
      case DYNAMIC_QUEUE_CONSTANTS.CASE_ID:
        return ENTITY_NAME.CASE_LOWER
      case DYNAMIC_QUEUE_CONSTANTS.DOCUMENT_ID:
        return DYNAMIC_QUEUE_CONSTANTS.DOCUMENT
      default:
        return DYNAMIC_QUEUE_CONSTANTS.WEB_LOWERCASE
    }
  }

  const getNoWorkLeftMessage = (isNoPermission: boolean) => {
    if (isNoPermission) {
      return STRINGS.UNABLE_GET_WORK
    }
    return entityName === ENTITY_NAME.CASE_LOWER
      ? DYNAMIC_QUEUE_MESSAGES.CASE_UNAVAILABLE
      : DYNAMIC_QUEUE_MESSAGES.INTAKE_UNAVAILABLE
  }

  const getWorkAgents = async () => {
    if (getWorkInFlightRef.current) {
      return
    }

    getWorkInFlightRef.current = true
    setIsGetWorkLoading(true)

    if (!isSuperAdmin() && Object.keys(programPermissions).length === 0) {
      getWorkInFlightRef.current = false
      setIsGetWorkLoading(false)
      return
    }

    try {
      dispatch(showLoader())
      let serviceNames: string[] = []
      if (
        !isSuperAdmin() &&
        queueData?.entity_name?.toLowerCase() === ENTITY_NAME.CASE_LOWER
      ) {
        serviceNames =
          programPermissionsObject.Queue_Get_Work_Services(programPermissions)
      }
      if (
        !isSuperAdmin() &&
        queueData?.entity_name?.toLowerCase() !== ENTITY_NAME.CASE_LOWER &&
        userProfile === NAMESPACES.STANDARD_USER
      ) {
        serviceNames = ['Benefit Verification']
      }
      const response = await handleGetWorkConditionally(
        id,
        userId?.toString(),
        serviceNames,
        programServices
      )
      if (response) {
        const responseArr = response?.data?.message?.split(' ')
        const isWorkAssigned =
          responseArr?.at(0) !== 'No' && responseArr?.at(0) !== 'You'
        if (isWorkAssigned) {
          const match = response?.data?.message?.match(
            /(document_id|case_id|intake_id|enrollment_id)\s*:\s*([A-Za-z0-9_.-]+),\s*id\s*:\s*(\d+)/
          )
          const idType = match[1]
          const caseId = match[2] ?? ''
          const id = match[3] ?? ''
          const assignedQueueConfig = getAssignedQueueConfig(idType)
          const successMessage = `${DYNAMIC_QUEUE_MESSAGES.ASSIGNED_NEW_WORK} ${assignedQueueConfig}: ${caseId}`
          dispatch(
            addToaster({
              id: uuid(),
              message: successMessage,
              type: 'success',
            })
          )

          if (idType === 'case_id') {
            await assignUnassignTasksWithCases(
              [id],
              user as DropdownType<string> | null
            )
            fetchEntityData(apiFilter, rowPerPage, currentPage - 1)
            openNewWindow(
              `/entity/${entityid}/workflow/review/${id}?message=${encodeURIComponent(
                successMessage
              )}`
            )
          } else if (idType === 'enrollment_id') {
            navigate(`${id}/${caseEntityId}/hcp`)
          } else if (idType === DYNAMIC_QUEUE_CONSTANTS?.DOCUMENT_ID) {
            navigate(`/manage-queue/dynamic-queue/${entityid}/${id}`)
          } else {
            navigate(`${id}/${caseEntityId}`)
          }
        } else {
          const noWorkLeft = getNoWorkLeftMessage(responseArr?.at(0) === 'You')
          dispatch(
            addToaster({
              id: uuid(),
              message: noWorkLeft,
              type: 'error',
            })
          )
        }
      }
    } catch (err) {
      const errorMessage =
        (err as AxiosError<ErrorResponseData>).response?.data?.message ?? ''
      dispatch(
        addToaster({
          id: uuid(),
          message: errorMessage,
          type: 'error',
        })
      )
    } finally {
      dispatch(hideLoader())
      getWorkInFlightRef.current = false
      setIsGetWorkLoading(false)
    }
  }

  const handleGetWorkConditionally = async (
    id: string | undefined,
    userId: string | undefined,
    serviceNames: string[],
    programServices: { [key: string]: number[] }
  ) => {
    const hasMultiProductSetting = siteSettings?.find(
      (item) => item.key === 'hasMultiProduct'
    )?.value
    const hasMultiProduct =
      hasMultiProductSetting === true || hasMultiProductSetting === 'true'

    if (
      hasMultiProduct &&
      queueData?.entity_name?.toLowerCase() ===
        QUEUE_STRINGS.HCP_PORTAL_ENTITY_LOWERCASE
    ) {
      return assignWebCasesQueueToAgent([], userId, id, programServices)
    } else {
      return getOldestWorkForAgentAPI(
        Number(id),
        Number(userId),
        serviceNames,
        programServices
      )
    }
  }

  const getCommunicationStatuses = async () => {
    try {
      const response = await generateCommuncationStatusesAPI()
      if (response) {
        setCommunicationStatuses(
          response?.data?.map((res: { label: string; id: string }) => ({
            label: res?.label,
            id: res?.id,
          }))
        )
      }
    } catch (err) {
      console.error(err)
    }
  }

  const isValidBulkPrint = () => {
    return (
      queueType === ENTITY_NAME.COMM_TYPE_LETTER &&
      selectedRows.length >= 1 &&
      (isSuperAdmin() ||
        (!printMailUserConfig?.isAssignedToOthers &&
          !printMailUserConfig?.unassignedLetters)) &&
      !printMailUserConfig?.letterStatus?.isDiscard &&
      !printMailUserConfig?.letterStatus?.isInvalid
    )
  }

  const isValidMarkAsCompleted = () => {
    return (
      queueType === ENTITY_NAME.COMM_TYPE_LETTER &&
      selectedRows.length >= 1 &&
      (isSuperAdmin() ||
        (!printMailUserConfig?.isAssignedToOthers &&
          !printMailUserConfig?.unassignedLetters)) &&
      printMailUserConfig?.letterStatus?.isProcessing &&
      !printMailUserConfig?.letterStatus?.isDiscard &&
      !printMailUserConfig?.letterStatus?.isPending &&
      !printMailUserConfig?.letterStatus?.isInvalid
    )
  }

  const handleOpenActionModal = (): DropdownType<unknown, string>[] => {
    return PRINT_MAIL_ACTIONS?.filter((item) => {
      if (item?.value === PRINT_MAIL_ACTIONS_ENUM.PRINT)
        return isValidBulkPrint()
      else if (item?.value === PRINT_MAIL_ACTIONS_ENUM.COMPLETED)
        return isValidMarkAsCompleted()
      else return true
    })
  }
  const handleActionSelect = async <T,>(selectedOption: DropdownType<T>) => {
    const selectedActions = selectedOption?.value
    switch (selectedActions) {
      case PRINT_MAIL_ACTIONS_ENUM.COMPLETED:
        handleMarkAsCompleted()
        break

      case PRINT_MAIL_ACTIONS_ENUM.PRINT:
        handlePrint()
        break

      case PRINT_MAIL_ACTIONS_ENUM.DISCARDED:
        setvoidDiscradModalState({
          isOpen: true,
          message: NAMESPACES.DISCARD_LETTER_CONFIRMATION_MESSAGE,
          validationMessage: NAMESPACES.DISCARD_REASON_VALIDATION_MESSAGE,
          actionSelected: PRINT_MAIL_ACTIONS_ENUM.DISCARDED,
        })
        break
      case PRINT_MAIL_ACTIONS_ENUM.VOIDED:
        setvoidDiscradModalState({
          isOpen: true,
          message: NAMESPACES.VOID_LETTER_CONFIRMATION_MESSAGE,
          validationMessage: NAMESPACES.VOID_REASON_VALIDATION_MESSAGE,
          actionSelected: PRINT_MAIL_ACTIONS_ENUM.VOIDED,
        })
        break
    }
  }
  const onExportOption = async (item: string) => {
    if (props.isDashboard && props.onExportOption) {
      props?.onExportOption(item)
    }
  }

  const onQueueExportClick = useCallback(async () => {
    if (!listingLayout?.layout_data) return
    try {
      dispatch(showLoader())
      const layoutRelatedEntities: Record<string, { select: string[] }> = {}

      Object.entries(listingLayout.layout_data.added_fields ?? {}).forEach(
        ([fieldName, field]) => {
          if (
            field?.ui_data_type === componentNames.SINGLE_LOOKUP ||
            field?.ui_data_type === componentNames.CATEGORY
          ) {
            const selectFieldsFromSelected =
              field?.selected_fields
                ?.map((f) => f.field_name)
                .filter((name): name is string => Boolean(name)) ?? []
            const selectFieldsFromAdded = Object.keys(field.added_fields ?? {})

            const allSelectFields = Array.from(
              new Set([...selectFieldsFromSelected, ...selectFieldsFromAdded])
            )

            layoutRelatedEntities[fieldName] = {
              select: allSelectFields,
            }
          }
        }
      )

      const formatFilter: {
        filter_criteria: LookupSearchCriteria[]
        related_entities: TableFilterLookupObjectBody
      } =
        apiFilter ?? sortDirection
          ? (formatFilterConfig(apiFilter ?? {}, configColumns, 'Queue', {
              key: sortDirection?.key,
              direction: sortDirection?.direction?.toUpperCase(),
            }) as {
              filter_criteria: LookupSearchCriteria[]
              related_entities: TableFilterLookupObjectBody
            })
          : { filter_criteria: [], related_entities: {} }

      Object.keys(formatFilter.related_entities).forEach((key) => {
        if (layoutRelatedEntities[key]) {
          formatFilter.related_entities[key].select =
            layoutRelatedEntities[key].select
        }
      })

      if (!isSuperAdmin()) {
        const programNames = getProgramIds()?.map((id) => programs[id])
        const key = getKeyName(entityName)
        const permission = buildProgramViewPermission(programNames)
        initializeRelatedEntityFilter(formatFilter, key)
        formatFilter.related_entities[key].filters.push(permission)
      }

      const uiDataMappings = buildUiDataMappings(configColumns)

      const addedFields = listingLayout.layout_data.added_fields ?? {}
      const mergedRelatedEntities: RelatedEntityType = structuredClone({
        ...layoutRelatedEntities,
        ...formatFilter.related_entities,
      } as RelatedEntityType)
      Object.keys(mergedRelatedEntities).forEach((key) => {
        const addedField = addedFields[key]
        if (
          !(
            addedField?.ui_data_type === componentNames.SINGLE_LOOKUP ||
            addedField?.ui_data_type === componentNames.CATEGORY
          )
        )
          return
        if (!uiDataMappings[key]) return
        const fieldMappings =
          addedField?.selected_fields?.reduce<
            Record<string, { alias: string[] }>
          >((acc, field) => {
            if (!field.field_name) return acc

            let aliasLabel = addedField?.label || ''

            if (key in EXPORT_FIELD_ALIASES) {
              const entityAliases =
                EXPORT_FIELD_ALIASES[key as keyof typeof EXPORT_FIELD_ALIASES]
              if (field.field_name in entityAliases) {
                aliasLabel =
                  entityAliases[field.field_name as keyof typeof entityAliases]
              }
            }

            acc[field.field_name] = { alias: [aliasLabel] }
            return acc
          }, {}) ?? {}

        if (key === FIELD_NAMES.C_CASE_STATUSES) {
          const selectArray = (
            mergedRelatedEntities[key] as { select?: string[] }
          )?.select
          if (selectArray?.includes(FIELD_NAMES.OVERALL_CASE_STATUS)) {
            if (!fieldMappings[FIELD_NAMES.OVERALL_CASE_STATUS]) {
              fieldMappings[FIELD_NAMES.OVERALL_CASE_STATUS] = {
                alias: [
                  EXPORT_FIELD_ALIASES.c_case_statuses.overall_case_status,
                ],
              }
            }
          }
        }

        mergedRelatedEntities[key] = {
          ...(mergedRelatedEntities[key] as object),
          ui_data_mappings: fieldMappings,
          exclude_fields: [
            FIELD_NAMES.RECORD_ID,
            FIELD_NAMES.ENTITY_TYPE,
            FIELD_NAMES.CATEGORY,
          ],
        }
      })

      const filteredSelect = configColumns
        .map((col) => String(col.accessor))
        .filter(Boolean)
        .filter((field) =>
          queueColumns
            ? queueColumns.some(
                (col: TableColumn) => col.accessor === field && !col.isHidden
              )
            : true
        )
        .filter((field) => !field.includes('.'))

      const filteredUiDataMappings = Object.fromEntries(
        Object.entries(uiDataMappings).filter(
          ([key]) => !key.includes('.') && !mergedRelatedEntities[key]
        )
      )

      let queryOrderCounter = 1
      filteredSelect.forEach((fieldName) => {
        if (mergedRelatedEntities[fieldName]) {
          const relatedEntity = mergedRelatedEntities[fieldName] as {
            ui_data_mappings?: Record<
              string,
              { alias: string[]; queryOrder?: number[] }
            >
          }
          if (relatedEntity.ui_data_mappings) {
            Object.keys(relatedEntity.ui_data_mappings).forEach((subField) => {
              relatedEntity.ui_data_mappings![subField] = {
                ...relatedEntity.ui_data_mappings![subField],
                queryOrder: [queryOrderCounter++],
              }
            })
          }
        } else {
          if (filteredUiDataMappings[fieldName]) {
            ;(filteredUiDataMappings[fieldName] as {
              alias: string[]
              queryOrder?: number[]
            }) = {
              ...filteredUiDataMappings[fieldName],
              queryOrder: [queryOrderCounter++],
            }
          }
        }
      })

      const queueFilters = (queueFilterCriteria ?? []).map((filter) => {
        const queueFilter: QueueFilterType = {
          id: filter.id,
          field_name: filter.field_name,
          operation: filter.operation ?? FILTER_OPERATIONS.LIKE,
          sort_direction: filter.sort_direction,
          values: filter.values ?? [],
          order: filter.order,
        }

        if (filter.preceding_condition !== null) {
          queueFilter.preceding_condition = filter.preceding_condition
        }

        return queueFilter
      })

      const allFilterCriteria = [
        ...formatFilter.filter_criteria.map((filter) => ({
          field_name: filter.field_name,
          values: filter.values || [],
          operation: filter.operation || FILTER_OPERATIONS.LIKE,
          ...(filter.sort_direction && {
            direction: filter.sort_direction,
          }),
        })),
        ...queueFilters,
      ]

      const transformedFilters =
        allFilterCriteria.length > 0
          ? [
              {
                criteria: allFilterCriteria,
              },
            ]
          : []

      if (queueFilterRealtedEntities) {
        Object.entries(queueFilterRealtedEntities).forEach(
          ([entityKey, entityData]) => {
            if (entityData?.filters && mergedRelatedEntities[entityKey]) {
              if (
                !(mergedRelatedEntities[entityKey] as { filters?: unknown[] })
                  .filters
              ) {
                ;(
                  mergedRelatedEntities[entityKey] as { filters: unknown[] }
                ).filters = []
              }
              ;(
                mergedRelatedEntities[entityKey] as { filters: unknown[] }
              ).filters.push(...entityData.filters)
            }
          }
        )
      }

      const payload: ExportPayloadType = {
        entity_name: entityName,
        select: filteredSelect,
        related_entities: mergedRelatedEntities,
        ui_data_mappings: filteredUiDataMappings,
        filters: transformedFilters,
        exclude_fields: [
          FIELD_NAMES.RECORD_ID,
          FIELD_NAMES.ENTITY_TYPE,
          FIELD_NAMES.CATEGORY,
        ],
      }

      const { data } = await exportEntityDataByEntityIdLayoutIdApiForFilter(
        payload
      )
      const timestamp = new Date()
        .toISOString()
        .replace(/[-:T]/g, '')
        .slice(0, 15)
      downloadCSV(data, `${startCase(entityName)}${timestamp}.csv`)
      dispatch(
        addToaster({
          id: uniqueId(),
          message: NAMESPACES.EXPORT_SUCCESSFUL,
          type: 'success',
        })
      )
    } catch (error: unknown) {
      let message = NAMESPACES.EXPORT_ERROR
      let type: ToasterTypeValues = ToasterType.ERROR

      if (isAxiosError(error)) {
        const backendMessage = error.response?.data?.message
        const statusCode = error.response?.status

        if (
          statusCode === HTTP_STATUS_CONSTANTS.SERVER_ERROR ||
          statusCode === HTTP_STATUS_CONSTANTS.GATEWAY_TIMEOUT ||
          !statusCode
        ) {
          message = NAMESPACES.EXPORT_RECORD_LIMIT_EXCEEDED
          type = ToasterType.WARNING
        } else if (
          statusCode === HTTP_STATUS_CONSTANTS.CONFLICT &&
          backendMessage
        ) {
          const parsed = parseErrorMessage(backendMessage)

          if (parsed.type === NAMESPACES.WARN) {
            message = parsed.message
            type = ToasterType.WARNING
          }
        }
      } else {
        message = NAMESPACES.EXPORT_RECORD_LIMIT_EXCEEDED
        type = ToasterType.WARNING
      }
      dispatch(
        addToaster({
          id: uniqueId(),
          message,
          type,
        })
      )
      console.log(error)
    } finally {
      dispatch(hideLoader())
    }
  }, [
    listingLayout,
    entityName,
    apiFilter,
    sortDirection,
    configColumns,
    dispatch,
  ])

  useEffect(() => {
    window.addEventListener(ENTITY_TABLE_EXPORT_EVENT, onQueueExportClick)
    return () =>
      window.removeEventListener(ENTITY_TABLE_EXPORT_EVENT, onQueueExportClick)
  }, [onQueueExportClick])

  useEffect(() => {
    fetchLayoutById(entityid ?? '-1', layoutid ?? '-1')
    if (id) fetchQueueById(Number(id))
  }, [entityid, layoutid, id])

  useEffect(() => {
    if (hasFetchedCaseStatusesRef.current) return
    hasFetchedCaseStatusesRef.current = true

    const fetchCompletedStatuses = async () => {
      try {
        const response = await getCaseStatuses({
          entity_name: NAMESPACES.CASE_STATUSES,
          select: ['name', 'id'],
        })
        if (response?.data) {
          const completedStatusIds = response?.data
            .filter(
              (status: { id: string | number; name: string }) =>
                status.name.includes(NAMESPACES.STATUS_COMPLETED) &&
                !status.name.includes(NAMESPACES.STATUS_NOT_COMPLETED)
            )
            .map((status: { id: string | number; name: string }) =>
              String(status.id)
            )

          setCompletedStatus(completedStatusIds)
        }
      } catch (error) {
        hasFetchedCaseStatusesRef.current = false
        console.error(NAMESPACES.STATUS_ERROR_MSG, error)
      }
    }

    fetchCompletedStatuses()
  }, [userId, entityName, getCaseStatuses])

  useEffect(() => {
    const fetchCaseId = async () => {
      const caseEntityData = await fetchEntityIdByName(
        dispatch,
        ENTITY_NAME.CASE_LOWER
      )
      setCaseEntityId(caseEntityData?.id)
    }
    if (isEmpty(caseEntityId)) fetchCaseId()
  }, [selectedClientName])

  useEffect(() => {
    getWorkInFlightRef.current = false
    setIsGetWorkLoading(false)
  }, [selectedTenant?.id])

  useEffect(() => {
    if (queueType === COMM_TEMPLATE.LETTER_LOWECASE) {
      getCommunicationStatuses()
    }
  }, [queueType])

  useEffect(() => {
    if (
      listingLayout &&
      (isSuperAdmin() || Object.keys(programPermissions).length)
    ) {
      setSelectedRows([])
      setCompleteSelectedRows([])
      setHeaderValues({ selected: false })
    }
  }, [listingLayout, entityName, entityid, layoutid, id, programPermissions])

  useEffect(() => {
    if (selectedRows.length === 0 || entityData.length === 0) {
      setPrintMailUserConfig(printMailInitialState)
      return
    }

    const getRowById = (id: string) =>
      entityData.find((item) => item.id?.toString() === id.toString())

    const addUnique = (
      map: { [key: string]: string[] },
      key: string,
      value: string
    ) => {
      if (!map[key]) map[key] = []
      if (!map[key].includes(value)) map[key].push(value)
    }
    if (entityName === ENTITY_NAME.CASE_LOWER) {
      const programServicesIds: { [key: string]: string[] } = {}

      selectedRows.forEach((id: string) => {
        const row = getRowById(id)
        const programId = row?.['programs.id']?.toString()
        const serviceId = row?.['services.id']?.toString()
        if (programId && serviceId) {
          addUnique(programServicesIds, programId, serviceId)
        }
      })
      setProgramServiceIds(programServicesIds)
    } else if ((allPermissions ?? [])?.length > 0) {
      const programPermissionIds: { [key: string]: string[] } = {}
      const intakePermissionId = (
        allPermissions?.find(
          (data) => data?.name === PERMISSION_MODULES.INTAKE_TRIAGE
        )?.id ?? -1
      ).toString()
      const documentPermissionId = (
        allPermissions?.find(
          (data) => data?.name === PERMISSION_MODULES.MANAGE_ATTACHMENTS
        )?.id ?? -1
      ).toString()
      const printMailPermissionId = (
        allPermissions?.find(
          (data) => data?.name === PERMISSION_MODULES.PRINT_MAIL
        )?.id ?? -1
      ).toString()

      selectedRows.forEach((id: string) => {
        const row = getRowById(id)
        const programId = (
          row?.['programs.id'] ?? row?.['hcp_program.id']
        )?.toString()
        const communicationType = row?.['category_communication_type.label']

        if (programId) {
          const permissionId =
            communicationType === COMM_TEMPLATE.LETTER_EN
              ? printMailPermissionId
              : entityName === ENTITY_NAME?.AE_PC_DOCUMENT
              ? documentPermissionId
              : intakePermissionId
          addUnique(programPermissionIds, programId, permissionId)
        }
      })
      setProgramServiceIds(programPermissionIds)
    }
    if (queueType === ENTITY_NAME.COMM_TYPE_LETTER) {
      setPrintMailUserConfig(printMailInitialState)
      selectedRows.forEach((id: string) => {
        const row = getRowById(id)
        if (!row?.users) {
          setPrintMailUserConfig((prev) => ({
            ...prev,
            unassignedLetters: true,
          }))
        }
        if (row?.users && row?.['users.id'] !== userId) {
          setPrintMailUserConfig((prev) => ({
            ...prev,
            isAssignedToOthers: true,
          }))
        }

        switch (row?.['category_status.label']) {
          case COMMUNICATION_STATUSES.PENDING_DISPATCH:
            setPrintMailUserConfig((prev) => ({
              ...prev,
              letterStatus: {
                ...prev.letterStatus,
                isPending: true,
              },
            }))
            break

          case COMMUNICATION_STATUSES.PROCESSING_PRINTING:
            setPrintMailUserConfig((prev) => ({
              ...prev,
              letterStatus: {
                ...prev.letterStatus,
                isProcessing: true,
              },
            }))
            break

          case COMMUNICATION_STATUSES.DISCARDED:
            setPrintMailUserConfig((prev) => ({
              ...prev,
              letterStatus: {
                ...prev.letterStatus,
                isDiscard: true,
              },
            }))
            break

          default:
            setPrintMailUserConfig((prev) => ({
              ...prev,
              letterStatus: {
                ...prev.letterStatus,
                isInvalid: true,
              },
            }))
            break
        }
      })
    }
  }, [selectedRows, entityData, allPermissions])

  useEffect(() => {
    {
      !props.isDashboard &&
        dispatch(
          setClientDropdown({
            isVisible: true,
            onOptionChange: onClientOptionChange,
            setModal: setModal,
            isNested:
              props?.isCaseWorkBasket || props?.isTaskWorkBasket
                ? undefined
                : true,
            isGlobalVisible: false,
          })
        )
    }
  }, [location])

  return (
    <div ref={ref} className="h-[100%] font-primary flex flex-col">
      <div className="flex flex-col">
        <div className="flex flex-col grid-cols-2 justify-between">
          <div
            className={`flex justify-between items-center px-3 ${
              props.isTaskWorkBasket || props.isCaseWorkBasket ? 'py-3' : 'py-2'
            } border-b-2`}
          >
            <div className="flex items-center gap-3">
              {getName().length > 0 && (
                <h2 className="text-base font-primary font-medium">
                  {getName()}
                </h2>
              )}
              <div className="flex justify-start items-center gap-4">
                {queueData?.entity_name?.toLowerCase() ===
                  ENTITY_NAME.CASE_LOWER && (
                  <div className="w-[11.875rem] hidden">
                    {' '}
                    {/*  TODO: Keep it hidden for now */}
                    <DropDownList
                      dataQaId="available-agents-drop-down"
                      triggerButtonLabel={
                        DYNAMIC_QUEUE_CONSTANTS.AVAILABLE_AGENTS
                      }
                      filterOptions={allAvailableAgents}
                      handleSearch={(e) =>
                        handleSearch(
                          e,
                          DYNAMIC_QUEUE_CONSTANTS.AVAILABLE_AGENTS
                        )
                      }
                      searchPlaceholder={DYNAMIC_QUEUE_CONSTANTS.SEARCH}
                      showButton={false}
                      onApply={(selected: DropdownType<string> | null) =>
                        handleAssign(selected)
                      }
                      onCancel={noop}
                      cancelButtonLabel={DYNAMIC_QUEUE_CONSTANTS.CANCEL}
                      applyButtonLabel={DYNAMIC_QUEUE_CONSTANTS.ASSIGN}
                      modalCss="min-w-[22rem] min-h-[23.875rem]"
                      optionCss="h-[2.5rem] border flex items-center px-2 mb-1 rounded justify-between"
                      selectOption={false}
                      optionListHeight="h-[17.5rem]"
                      icon={<SvgAvailabelAgentsListing />}
                      arrowIcon={true}
                      emptyDataMessage={NAMESPACE.NO_DATA_FOUND}
                    />
                  </div>
                )}

                {shouldShowAgentDropdown && (
                  <DropDownList
                    dataQaId="agents-drop-down"
                    onBtnClick={fetchAgentsData}
                    triggerButtonLabel={
                      DYNAMIC_QUEUE_CONSTANTS.ASSIGN_TO_AGENTS
                    }
                    filterOptions={allAgents}
                    handleSearch={(e) =>
                      handleSearch(e, DYNAMIC_QUEUE_CONSTANTS.ASSIGN_TO_AGENTS)
                    }
                    searchPlaceholder={DYNAMIC_QUEUE_CONSTANTS.SEARCH_AGENTS}
                    showButton={true}
                    onApply={(
                      selected: { label: string; value: string } | null
                    ) => handleAssign(selected)}
                    onCancel={noop}
                    cancelButtonLabel={DYNAMIC_QUEUE_CONSTANTS.CANCEL}
                    applyButtonLabel={DYNAMIC_QUEUE_CONSTANTS.ASSIGN}
                    modalCss="min-w-[12.8rem] max-w-[15rem] ml-[10rem]"
                    optionCss="h-[2.5rem] border-border-100 flex items-center cursor-pointer px-2 hover:text-white"
                    selectOption={true}
                    optionListHeight="h-[10rem]"
                    arrowIcon={true}
                    emptyDataMessage={NAMESPACE.NO_DATA_FOUND}
                  />
                )}
                {queueType === ENTITY_NAME.COMM_TYPE_LETTER &&
                  shouldShowActionDropdown && (
                    <ActionsDropDown
                      handleOpenOptions={async () => handleOpenActionModal()}
                      handleValueSelect={async (selectedOption) =>
                        handleActionSelect(selectedOption)
                      }
                    />
                  )}
                {shouldShowAgentDropdown && shouldShowBulkUnassign() && (
                  <CustomButton
                    color="primary"
                    dataQaId="unassign-agent"
                    onClick={() =>
                      setModal({
                        type: DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_BULK_UNASSIGN_MESSAGE,
                        state: true,
                      })
                    }
                  >
                    <span className="hover:text-primary-500">
                      {DYNAMIC_QUEUE_CONSTANTS.UNASSIGN}
                    </span>
                  </CustomButton>
                )}
                {selectedRows.length > 0 && (
                  <span className="font-light text-xs">
                    {selectedRows.length}{' '}
                    {selectedRows.length === 1
                      ? DYNAMIC_QUEUE_MESSAGES.ROW_SELECTED
                      : DYNAMIC_QUEUE_MESSAGES.ROWS_SELECTED}
                  </span>
                )}
              </div>
            </div>
            <div className="flex justify-end gap-5">
              {!props.isDashboard && (
                <ExportButtonDropdown
                  className="mr-2"
                  showCSV={true}
                  showExcel={false}
                  onExportOption={() =>
                    window.dispatchEvent(new Event(ENTITY_TABLE_EXPORT_EVENT))
                  }
                  customCSS="-translate-x-3/4"
                  dataQaId="correspondence-export-btn"
                />
              )}
              {props?.isCaseWorkBasket ||
              props?.isTaskWorkBasket ||
              props.isDashboard ? null : (
                <TableViewsDropdown
                  apiFilter={apiFilter}
                  setApiFilter={setApiFilter}
                  setIsMounted={() => (isMounted.current = true)}
                  contextType={CONTEXT_TYPE.QUEUE}
                  id={parseInt(id ?? '')}
                />
              )}
              {props?.isCaseWorkBasket ||
              props?.isTaskWorkBasket ||
              props.isDashboard ? null : (
                <div className="flex justify-end gap-5 items-center">
                  {userProfile !== USER_PROFILES.SUPPORT &&
                  userProfile !== USER_PROFILES.READ_ONLY_USER
                    ? // Condition to hide get work for print mail queue
                      queueType !== ENTITY_NAME.COMM_TYPE_LETTER && (
                        <>
                          <SvgVerticalSplitter height={'2rem'} />
                          <CustomButton
                            ref={getWorkButtonRef}
                            isFilled={true}
                            onClick={handleGetWorkAssignment}
                            disabled={isReadOnlyUser() || isGetWorkLoading}
                            aria-busy={isGetWorkLoading}
                            onKeyDown={(e) => {
                              if (
                                getWorkInFlightRef.current &&
                                (e.key === 'Enter' || e.key === ' ')
                              ) {
                                e.preventDefault()
                                e.stopPropagation()
                              }
                            }}
                          >
                            {NAMESPACES.GET_WORK}
                          </CustomButton>
                        </>
                      )
                    : null}
                </div>
              )}
              {props.isDashboard && (
                <ExportButtonDropdown
                  showCSV={true}
                  showExcel={false}
                  onExportOption={onExportOption}
                  customCSS="-translate-x-3/4"
                  dataQaId="correspondence-export-btn"
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-1 min-h-0 flex flex-col">
        <QueueTable
          queueData={queueData}
          entityData={entityData}
          listingLayout={listingLayout}
          fetchEntityData={fetchEntityData}
          totalPages={totalPages}
          rowsPerPage={rowPerPage}
          totalElements={totalElements}
          numberOfElements={numberOfElements}
          setEntityData={setEntityData}
          setSelectedRows={setSelectedRows}
          selectedRows={selectedRows}
          sendPageDataToDynamicQueue={handlePageDataFromChild}
          sendFilterDataFromChild={handleFilterDataFromChild}
          // showTableType={showTableType}
          setHeaderValues={setHeaderValues}
          entityName={entityName}
          headerValues={headerValues}
          setSortDirection={setSortDirection}
          sortDirection={sortDirection}
          isCaseWorkBasket={props?.isCaseWorkBasket}
          isTaskWorkBasket={props?.isTaskWorkBasket}
          queueType={queueType}
          queueFilterCriteria={queueFilterCriteria}
          queueFilterRealtedEntities={queueFilterRealtedEntities}
          apiFilter={apiFilter}
          setApiFilter={setApiFilter}
          isMounted={isMounted}
          isDashboard={props.isDashboard ?? false}
          refetchKeyFromDashboard={props.refetchKeyFromDashboard ?? 0}
          setCompleteSelectedRows={setCompleteSelectedRows}
          dashboardListName={props.dashboardListName ?? ''}
          handleAssignUnassignForDashboard={(
            agent: AgentType | null,
            rows: DataType[]
          ) => props?.handleAssignUnassignForDashboard?.(agent, rows)}
          caseEntityId={caseEntityId}
        />
      </div>
      {modal.state && (
        <Modal
          isOpen={modal.state}
          closeModal={() => setModal({ type: '', state: false })}
          showCloseButton={false}
        >
          <ConfirmationModal
            message={
              modal.type === 'redirect'
                ? QUEUE_STRINGS?.CHANGE_CLIENT_MESSAGE
                : modal.type ===
                  DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_BULK_UNASSIGN_MESSAGE
                ? entityName === ENTITY_NAME.CASE_LOWER
                  ? DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_BULK_UNASSIGN_MESSAGE
                  : DYNAMIC_QUEUE_MESSAGES.CONFIRMATION_BULK_UNASSIGN_INTAKE_MESSAGE
                : ''
            }
            handleNo={onClientModalCancel}
            handleYes={onClientModalConfirm}
          />
        </Modal>
      )}
      {voidDiscradModalState?.isOpen && (
        <ConfirmDialogWithReason
          open={voidDiscradModalState?.isOpen}
          onCancel={() =>
            setvoidDiscradModalState({
              isOpen: false,
              message: '',
              validationMessage: '',
              actionSelected: '',
            })
          }
          onConfirm={(reason) => {
            handleMarkAsVoidedDiscarded(
              reason,
              voidDiscradModalState.actionSelected as
                | PRINT_MAIL_ACTIONS_ENUM.DISCARDED
                | PRINT_MAIL_ACTIONS_ENUM.VOIDED
            )
          }}
          message={voidDiscradModalState?.message}
          width="w-[38.5rem]"
          validationMessage={voidDiscradModalState?.validationMessage}
          showCloseButton={true}
        />
      )}
    </div>
  )
}
export default DynamicQueues
